/**
 * Stored value of an IMAGE-typed additional field (guest.additionalFields[name]).
 * Written ONLY by the backend presign→confirm flow — generic guest updates must
 * either echo it deep-equal (ignored) or send null/blank (= clear). KEEP IN SYNC
 * with the backend value contract (af-images master spec 2026-07-10).
 */
export type AfImageValue = {
  /** R2 object key: af-images/{eventId}/{guestId}/{fieldLower}/{uuid}_{safeFileName} */
  key: string;
  contentType: string;
  size: number;
};

/** Loose runtime check for an AfImageValue-shaped stored value. */
export function isAfImageValue(value: unknown): value is AfImageValue {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    return false;
  }
  const v = value as Record<string, unknown>;
  return (
    typeof v.key === "string" &&
    v.key.startsWith("af-images/") &&
    typeof v.contentType === "string" &&
    typeof v.size === "number"
  );
}
